import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Check, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { getPackages } from "@/lib/api";

export const Packages = ({ showHeader = true }) => {
  const { data: packages = [] } = useQuery({ queryKey: ["packages"], queryFn: getPackages });

  return (
    <section id="paketler" className="section-pad bg-[#141517]" data-testid="packages-section">
      <div className="container-lux">
        {showHeader && (
          <Reveal>
            <div className="text-center max-w-2xl mx-auto">
              <span className="eyebrow justify-center">Paketler</span>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
                Üç paket, içindekiler açık açık
              </h2>
              <p className="text-[#9A9387] mt-4">
                Size en uygun paketi seçin; tarihinizi alın, konseptinizi birlikte planlayalım.
              </p>
            </div>
          </Reveal>
        )}

        <div className="grid lg:grid-cols-3 gap-5 lg:gap-6 mt-12 items-stretch">
          {packages.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08} className="h-full">
              <div
                className={`relative h-full flex flex-col rounded-2xl bg-[#FBF7EF] p-7 border ${
                  p.highlight
                    ? "border-[rgba(200,162,74,0.6)] shadow-[0_0_0_1px_rgba(200,162,74,0.35),0_22px_50px_rgba(0,0,0,0.4)] lg:-translate-y-3"
                    : "border-black/5"
                }`}
              >
                {p.highlight && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 bg-[#C8A24A] text-[#141517] text-xs font-semibold px-3 py-1 rounded-full">
                    <Star className="w-3.5 h-3.5 fill-[#141517]" /> En Çok Tercih
                  </div>
                )}
                <div className="text-xs uppercase tracking-[0.16em] text-[#9a7b23]">{p.subtitle}</div>
                <h3 className="font-display text-3xl text-[#141517] mt-1">{p.name}</h3>
                <div className="text-sm text-[#5B5F66] mt-1">{p.duration}</div>
                <div className="font-display text-2xl text-[#141517] mt-4">{p.price_display}</div>
                <div className="h-px bg-black/10 my-5" />
                <ul className="space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-[#2A2D31]">
                      <Check className="w-4 h-4 mt-0.5 text-[#3F6B5B] shrink-0" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/iletisim" className="mt-7" data-testid={`package-select-${p.id}`}>
                  <Button
                    className={`w-full font-semibold ${
                      p.highlight
                        ? "bg-[#C8A24A] text-[#141517] hover:bg-[#D7B86A]"
                        : "bg-[#141517] text-[#F7F2E8] hover:bg-[#2A2D31]"
                    }`}
                    data-testid="package-select-button"
                  >
                    Bu Paketi Seç · Teklif Al
                  </Button>
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-center text-xs text-[#7C766B] mt-6">
          * Fiyatlar başlangıç fiyatıdır ve konsept/mekân sayısına göre değişir. Net teklif için bize ulaşın.
        </p>
      </div>
    </section>
  );
};

export default Packages;
